module.exports = __webpack_public_path__ + "img/comments-narrow-min.4df38d71.jpg";